<template>
  <div
    :key="uniqueKey" class="rich-wrapper"
    :style="showRichRootStyle">
    <div
      ref="editable"
      class="rich-show-inner"
      :style="showRichTextStyle">
    </div>
  </div>
</template>

<script>
import ChartMixin from '@/components/charts/mixin'
import { getRichTextContainerStyle, isRichTextIndicatorReadonly } from '@/utils/richTextTypography'

export default {
  name: 'ShowRich',
  mixins: [ChartMixin],
  props: {
    config: {
      type: Object,
    },
    globalConfig: {
      type: Object,
    },
    componentType: {
      type: String,
    },
    filterParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      uniqueKey: 'xxx',
    }
  },
  computed: {
    showRichRootStyle () {
      return {
        width: this.config.chartWidth + 'px',
        height: this.config.chartHeight + 'px',
      }
    },
    showRichTextStyle () {
      const indicator = isRichTextIndicatorReadonly(this.dataSource, this.selectedIndicatorIdList)
      return getRichTextContainerStyle({
        titleStyle: this.config?.chartSet?.titleStyle,
        omitCharacterStyles: !indicator,
      })
    },
  },
  watch: {
    'config.chartViewData.chartData': {
      handler (val) {
        if (!this.$refs.editable) return
        this.$refs.editable.innerHTML = val == null ? '' : String(val)
      },
    },
  },
  created () {
    this.uniqueKey = Math.random()
  },
  mounted () {
    this.$refs.editable.innerHTML = this.config.chartViewData.chartData || ''
  },
}
</script>

<style lang='scss' scoped>
.rich-wrapper {
  color: #fff;
  overflow: hidden ;
  padding: 5px;
}

.rich-show-inner ::v-deep .rich-indicator-line {
  margin: 0;
  font-weight: inherit;
  font-style: inherit;
  text-decoration: inherit;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
</style>
